"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _BaggageSummary = _interopRequireDefault(require("./BaggageSummary.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var BaggageSummaryContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__BaggageSummaryContainer",
  componentId: "sc-5b7xfp-0"
})(["background-color:", ";padding:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyLighter;
}, function (_ref2) {
  var theme = _ref2.theme,
      isMobile = _ref2.isMobile;
  return isMobile ? "".concat(theme.space.small, " ").concat(theme.space.XSmall) : "".concat(theme.space.XSmall, " ").concat(theme.space.semi, " ").concat(theme.space.XSmall, " ").concat(theme.space.small);
});

var MainContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__MainContainer",
  componentId: "sc-5b7xfp-1"
})(["display:flex;flex-flow:row wrap;"]);

var CheckBoxContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__CheckBoxContainer",
  componentId: "sc-5b7xfp-2"
})([""]);

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__Wrapper",
  componentId: "sc-5b7xfp-3"
})(["display:flex;flex-flow:", ";flex:1;"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 'column wrap' : 'row wrap';
});

var SummaryContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__SummaryContainer",
  componentId: "sc-5b7xfp-4"
})(["display:flex;flex-direction:row;flex:", ";"], function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? 1 : 3;
});

var BaggageDetails = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__BaggageDetails",
  componentId: "sc-5b7xfp-5"
})(["display:flex;justify-content:flex-start;flex:2;"]);

var BaggageInfo = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__BaggageInfo",
  componentId: "sc-5b7xfp-6"
})(["flex:1;"]);

var BaggageStatus = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__BaggageStatus",
  componentId: "sc-5b7xfp-7"
})(["display:flex;flex-flow:row wrap;justify-content:flex-end;align-items:flex-start;", ""], function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? '' : 'flex : 2';
});

var StatusMessage = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__StatusMessage",
  componentId: "sc-5b7xfp-8"
})(["background-color:", ";font-family:", ";color:", ";font-size:", ";line-height:", ";font-weight:", ";border-radius:", ";padding:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.tertiaryLight;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily.default;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.tertiary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.XSmall;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.lineHeight.small;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeight.medium;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.borderRadius.normal;
}, function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.space.nano, " ").concat(theme.space.micro);
});

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "BaggageSummary__IconWrapper",
  componentId: "sc-5b7xfp-9"
})([""]);

var BaggageSummary = function BaggageSummary(props) {
  var accessible = props.accessible,
      theme = props.theme,
      isMobile = props.isMobile,
      heading = props.heading,
      description = props.description,
      icon = props.icon,
      statusMsg = props.statusMsg,
      smallBagWeight = props.smallBagWeight;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var summaryDescription = description.replace('{0}', smallBagWeight);

  var getBaggageHeadingText = function getBaggageHeadingText() {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      theme: theme,
      type: _constant.TEXT_TYPE.HEADING.type,
      bold: true,
      color: _constant.TEXT_TYPE.HEADING.color,
      marginLeft: "micro"
    }, heading);
  };

  var getBaggageDescText = function getBaggageDescText() {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      theme: theme,
      type: isMobile ? _constant.TEXT_TYPE.MOBILE_DESC.type : _constant.TEXT_TYPE.DESC.type,
      color: isMobile ? _constant.TEXT_TYPE.MOBILE_DESC.color : _constant.TEXT_TYPE.DESC.color
    }, summaryDescription);
  };

  var getBaggageStatus = function getBaggageStatus() {
    return /*#__PURE__*/_react.default.createElement(StatusMessage, null, statusMsg);
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(BaggageSummaryContainer, {
      tabIndex: tabIndex,
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(MainContainer, null, /*#__PURE__*/_react.default.createElement(CheckBoxContainer, null, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      theme: theme,
      accessible: accessible,
      disableBottomMargin: true,
      disableCheckbox: true,
      disabledWithSelected: true,
      isSelected: false
    })), /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      accessible: accessible,
      color: _constant.ICON_TYPE.normal.color,
      fontsize: _constant.ICON_TYPE.normal.size,
      icon: icon
    })), /*#__PURE__*/_react.default.createElement(Wrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(SummaryContainer, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(BaggageDetails, null, getBaggageHeadingText()), !isMobile ? /*#__PURE__*/_react.default.createElement(BaggageInfo, {
      isMobile: isMobile
    }, getBaggageDescText()) : /*#__PURE__*/_react.default.createElement(BaggageStatus, {
      isMobile: isMobile
    }, getBaggageStatus())), !isMobile ? /*#__PURE__*/_react.default.createElement(BaggageStatus, {
      isMobile: isMobile
    }, getBaggageStatus()) : /*#__PURE__*/_react.default.createElement(BaggageInfo, {
      isMobile: isMobile
    }, getBaggageDescText()))));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

BaggageSummary.propTypes = _BaggageSummary.default.PropTypes;
BaggageSummary.defaultProps = _BaggageSummary.default.DefaultProps;
var _default = BaggageSummary;
exports.default = _default;